import {useCallback, useContext, useState} from "react";
import {Form} from "antd";
import UserContext from "../../../context/users";
import {createTemplate} from "../../../services/templates";
import {useNavigate} from "react-router-dom";
import { toast } from "sonner";
import TemplateForm from "../Form";


export default function CreateTemplate() {
  const navigate = useNavigate()
  const [user] = useContext(UserContext);

  const [form] = Form.useForm()
  const properties = Form.useWatch(['args', 'parameters', 'properties'], form)
  const trigger = Form.useWatch('args', form);
  const [loading, setLoading] = useState(false)

  const onFinish = useCallback(async (values) => {
    setLoading(true)
    values.args.parameters.type = 'object';
    const requiredFields = []
    if (values?.args?.parameters?.properties) {
      let newProperties = {};
      for (const value of values.args.parameters.properties) {
        newProperties[value.name] = {
          type: value.type,
          description: value.description,
          enum: value.limitOptions ? value.enum : []
        }

        if (value.items)
          newProperties[value.name].items = value.items

        if (value.required)
          requiredFields.push(value.name);
      }
      values.args.parameters.required = requiredFields;
      values.args.parameters.properties = newProperties;
    }

    if (Object.keys(values?.args?.parameters?.properties ?? {}).length <= 0)
      delete values.args.parameters;

    const body = {
      args: values.args,
      generativeActionTemplates: values?.actions?.map((act) => ({
        type: act.type,
        action: act.action || {},
      })),
      companyID: user.companyID,
      description: values.description,
      name: values.name,
      isPublic: values.isPublic,
      interpretResponse: values.interpretResponse,
      copilotOnly: values.copilotOnly,
    }

    await createTemplate(body)
      .then(() => {
        toast.success("Template salvo com sucesso!")
        navigate("/templates")
      })
      .catch((err) => {
        console.error(err)
        toast.error("Houve um problema ao salvar o template")
      })
      .finally(() => setLoading(false))
  }, [user.companyID, navigate])

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <TemplateForm
        form={form}
        properties={properties}
        trigger={trigger}
        loading={loading}
      />
    </Form>
  )
}
